module.exports = __webpack_public_path__ + "img/bo.55892cc7.svg";